import Icon from 'scripts/components/basic/Icon.vue';
import VButton from 'scripts/components/basic/VButton.vue';
import TextInput from 'scripts/components/forms/TextInput.vue';
import EmailInput from 'scripts/components/forms/EmailInput.vue';
import SelectInput from 'scripts/components/forms/SelectInput.vue';
import KlaviyoForm from 'scripts/components/forms/KlaviyoForm.vue';
import Accordion from 'scripts/components/basic/Accordion.vue';
import AccordionGroup from 'scripts/components/basic/AccordionGroup.vue';
import ProductCard from 'scripts/components/product/product-card/ProductCard.vue';
import ProductCardBadges from 'scripts/components/product/product-card/ProductCardBadges.vue';
import ProductFormOptions from 'scripts/components/product/ProductFormOptions.vue';
import ProductInformation from 'scripts/components/product/ProductInformation.vue';
import SideCart from 'scripts/components/cart/SideCart.vue';
import CartAttributes from 'scripts/components/cart/CartAttributes.vue';
import CartRemoveLink from 'scripts/components/cart/CartRemoveLink.vue';
import CartIcon from 'scripts/components/cart/CartIcon.vue';

export default {
  Icon,
  VButton,
  TextInput,
  EmailInput,
  SelectInput,
  KlaviyoForm,
  Accordion,
  AccordionGroup,
  ProductCard,
  ProductCardBadges,
  ProductFormOptions,
  ProductInformation,
  SideCart,
  CartAttributes,
  CartRemoveLink,
  CartIcon,
};
